import React from "react";
import LegalLayout, { LegalBlock } from "../components/LegalLayout";

const Datenschutz = () => {
  return (
    <LegalLayout
      title="Datenschutz"
      subtitle="Informationen zur Verarbeitung deiner personenbezogenen Daten"
    >
      <LegalBlock heading="1. Verantwortlicher">
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist die
          ROI DES ROIS GmbH, Boelckestr. 62, 55252 Wiesbaden. Kontakt:{" "}
          <a href="mailto:info@roidesrois.de" className="text-gold hover-underline">
            info@roidesrois.de
          </a>
          .
        </p>
      </LegalBlock>

      <LegalBlock heading="2. Erhebung und Speicherung von Daten">
        <p>
          Wir erheben personenbezogene Daten, wenn du eine Bestellung aufgibst,
          ein Konto erstellst oder unseren Newsletter abonnierst. Dazu gehören
          Name, Anschrift, E-Mail-Adresse und Zahlungsinformationen. Diese Daten
          werden ausschließlich zur Abwicklung deiner Bestellung und zur
          Kommunikation mit dir verwendet.
        </p>
      </LegalBlock>

      <LegalBlock heading="3. Newsletter">
        <p>
          Wenn du unseren Newsletter abonnierst, verwenden wir deine
          E-Mail-Adresse, um dich über neue Editionen und Angebote zu
          informieren. Du kannst dich jederzeit über den Abmeldelink im Newsletter
          wieder austragen.
        </p>
      </LegalBlock>

      <LegalBlock heading="4. Cookies">
        <p>
          Unsere Website verwendet Cookies, um den Warenkorb und deine Sitzung
          zu speichern sowie die Nutzung der Seite zu analysieren. Du kannst die
          Speicherung von Cookies in deinen Browser-Einstellungen deaktivieren.
        </p>
      </LegalBlock>

      <LegalBlock heading="5. Deine Rechte">
        <p>
          Du hast das Recht auf Auskunft, Berichtigung, Löschung und
          Einschränkung der Verarbeitung deiner personenbezogenen Daten sowie ein
          Widerspruchsrecht. Wende dich hierfür bitte an die oben genannte
          E-Mail-Adresse.
        </p>
      </LegalBlock>

      <LegalBlock heading="6. Aufsichtsbehörde">
        <p>
          Bei Beschwerden kannst du dich an die zuständige
          Datenschutz-Aufsichtsbehörde wenden (Der Hessische Beauftragte für
          Datenschutz und Informationsfreiheit).
        </p>
      </LegalBlock>

      <p className="text-[#8d8779] text-sm pt-4">
        Hinweis: Dies ist eine allgemeine Vorlage. Bitte lasse den finalen
        Datenschutztext vor der Veröffentlichung rechtlich prüfen.
      </p>
    </LegalLayout>
  );
};

export default Datenschutz;
